module.exports = __webpack_public_path__ + "img/HSV21 Holzbach Innenraum Korridor Bild 5.d1129a47.jpg";